import { render, staticRenderFns } from "./locadorPrestador.vue?vue&type=template&id=17be7158&scoped=true"
import script from "./locadorPrestador.vue?vue&type=script&lang=js"
export * from "./locadorPrestador.vue?vue&type=script&lang=js"
import style0 from "./locadorPrestador.vue?vue&type=style&index=0&id=17be7158&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17be7158",
  null
  
)

export default component.exports